module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sellerPickerHolder"
  }, [_c('multiselect', {
    class: [_vm.size],
    attrs: {
      "options": _vm.options2,
      "allowEmpty": _vm.allowEmpty,
      "multiple": false,
      "group-values": "people",
      "showLabels": false,
      "group-label": "groupName",
      "placeholder": _vm.placeholder,
      "track-by": "id",
      "label": "brandName",
      "open-direction": "bottom"
    },
    on: {
      "input": _vm.update,
      "remove": _vm.remove
    },
    scopedSlots: _vm._u([{
      key: "singleLabel",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc d-flex flex-row align-items-center"
        }, [_c('span', {
          staticClass: "flexGrow1"
        }, [_vm._v(_vm._s(props.option.brandName))]), _vm._v(" "), (props.option.channelClosed && props.option.channelClosed == true) ? _c('span', {
          staticClass: "customTag bg-light dark fs-smaller px-2 radius-normal"
        }, [_vm._v("Closed")]) : _vm._e()])]
      }
    }, {
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc d-flex flex-row align-items-center"
        }, [_c('span', {
          staticClass: "flexGrow1"
        }, [_vm._v(_vm._s(props.option.brandName ? props.option.brandName : props.option.$groupLabel))]), _vm._v(" "), (props.option.channelClosed && props.option.channelClosed == true) ? _c('span', {
          staticClass: "customTag bg-light dark fs-smaller px-2 py-1 radius-normal"
        }, [_vm._v("Closed")]) : _vm._e(), _vm._v(" "), (props.option.protocolStatus && props.option.protocolStatus == 5) ? _c('span', {
          staticClass: "customTag bg-light dark fs-smaller px-2 py-1 radius-normal"
        }, [_vm._v("Blocked")]) : _vm._e()])]
      }
    }]),
    model: {
      value: (_vm.selectedSeller),
      callback: function($$v) {
        _vm.selectedSeller = $$v
      },
      expression: "selectedSeller"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No results.")])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-f2125c9e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2125c9e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/SellerPicker.vue
// module id = 1105
// module chunks = 0